// NOTICE: KAPTION-INTEGRATION — Emoji shortcode conversion utility
// Converts :shortcode: patterns (e.g. :moneybag:, :rocket:) to Unicode emojis
import emojiNameMap from 'emoji-name-map';

// Common aliases not covered by emoji-name-map
const ALIASES = {
  thumbsup: '👍',
  thumbs_up: '👍',
  thumbsdown: '👎',
  thumbs_down: '👎',
  envelope: '✉️',
  hankey: '💩',
  shipit: '🐿️',
};

/**
 * Convert :shortcode: patterns to Unicode emojis.
 * Unknown shortcodes are left as-is.
 *
 * @param {string} text - Input text that may contain :shortcode: patterns
 * @returns {string} Text with shortcodes replaced by Unicode emojis
 *
 * @example
 * convertEmojiShortcodes('Hello :wave: :rocket:')
 * // => 'Hello 👋 🚀'
 *
 * convertEmojiShortcodes(':moneybag: deal!')
 * // => '💰 deal!'
 *
 * convertEmojiShortcodes(':unknown_code:')
 * // => ':unknown_code:'
 */
export function convertEmojiShortcodes(text) {
  if (!text || typeof text !== 'string') return text;
  return text.replace(/:([a-z0-9_+-]+):/g, (match, name) => {
    const emoji = emojiNameMap.get(name) || ALIASES[name];
    return emoji || match;
  });
}
